/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tab_OwnershipInputs */

const cs_clients_tab_ownership = /** @type {(inputs: Clients_Tab_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastnictví`)
};

const en_clients_tab_ownership = /** @type {(inputs: Clients_Tab_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership`)
};

/**
* | output |
* | --- |
* | "Ownership" |
*
* @param {Clients_Tab_OwnershipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tab_ownership = /** @type {((inputs?: Clients_Tab_OwnershipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tab_OwnershipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tab_ownership(inputs)
	return cs_clients_tab_ownership(inputs)
});